module.exports = __webpack_public_path__ + "static/crane_header_mobile-3a6ffdc4c2c91133f8b0e5dc38ea8c61.png";